module.exports = __webpack_public_path__ + "assets/86fa6edc91f0313593f86fb4f7643c06.png";